import { createSelector } from 'reselect';
import userDux from 'src/redux/user';
import appDux from 'src/redux/app';
import utils from 'src/utils';

const { generateCommonMetricData } = utils.metrics;

const getCommonMetricData = createSelector(
  userDux.selectors.getUserProfile,
  appDux.selectors.getJobDetails,
  (user, job) => generateCommonMetricData(user, job),
);

export default {
  getCommonMetricData,
};
